<template>
  <div id="chart" v-if="transactionsStatus != 0">
    <apexchart
      height="100%"
      width="100%"
      type="bar"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
  <div v-else id="no-chart">
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="72"
        height="72"
      >
        <path fill="none" d="M0 0h24v24H0z" />
        <path
          d="M19.375 15.103A8.001 8.001 0 0 0 8.03 5.053l-.992-1.737A9.996 9.996 0 0 1 17 3.34c4.49 2.592 6.21 8.142 4.117 12.77l1.342.774-4.165 2.214-.165-4.714 1.246.719zM4.625 8.897a8.001 8.001 0 0 0 11.345 10.05l.992 1.737A9.996 9.996 0 0 1 7 20.66C2.51 18.068.79 12.518 2.883 7.89L1.54 7.117l4.165-2.214.165 4.714-1.246-.719zm8.79 5.931L10.584 12l-2.828 2.828-1.414-1.414 4.243-4.242L13.414 12l2.829-2.828 1.414 1.414-4.243 4.242z"
          fill="rgba(149,164,166,1)"
        />
      </svg>
    </div>
    <div>
    <h6>
      There is no transaction yet in any of the branches in your company today.
    </h6>
    </div>
  </div>
</template>

<script>
import axios from "axios";
let config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
};
export default {
  data() {
    return {
      branchreport: [],
      transactionsStatus: 0,
      chartOptions: {
        chart: {
          id: "chart",
          stacked: false,
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: [],
        },
        yaxis: [
          {
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: "#008FFB",
            },
            labels: {
              style: {
                colors: "#008FFB",
              },
            },
            title: {
              text: "Tickets sold",
              style: {
                color: "#008FFB",
              },
            },
            tooltip: {
              enabled: true,
            },
          },
          {
            opposite: true,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: "#00E396",
            },
            labels: {
              style: {
                colors: "#00E396",
              },
            },
            title: {
              text: "Amount collected(Frw)",
              style: {
                color: "#00E396",
              },
            },
          },
        ],
      },
      series: [
        {
          name: "Tickets sold",
          type: "column",
          data: [],
        },
        {
          name: "Amount collected",
          type: "column",
          data: [],
        },
      ],
    };
  },
  methods: {},
  mounted() {
    axios
      .get(
        "https://bookinga.herokuapp.com/api/v1/adminReport/fund/branch",
        config
      )
      .then((res) => {
        // console.log(res.data.data)
        this.branchreport = res.data.data;
        this.transactionsStatus = this.branchreport[0].count;
        if (transactionsStatus != 0) {
          for (let i = 0; i < this.branchreport.length; i++) {
            this.chartOptions.xaxis.categories[i] = this.branchreport[
              i
            ].branchname;
            this.series[0].data[i] = this.branchreport[i].count;
            this.series[1].data[i] = this.branchreport[i].total_fund;
          }
        }
      });
  },
};
</script>

<style lang="scss" scoped>
#chart {
  height: 100%;
  font-size: 0.85em;
  font-weight: 400;
  padding-top: 1.5%;
}
#no-chart {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
}
#no-chart>div{
  margin: 0;
  width: 95% !important;
  display: flex;
  justify-content: center;
  padding: 0.2em;
}
</style>
